import React from 'react';
import { TopBar } from './components/TopBar';
import { Header } from './components/Header';
import { CouponBanner } from './components/CouponBanner';
import { Hero } from './components/Hero';
import { TrustBar } from './components/TrustBar';
import { ShingleFocus } from './components/ShingleFocus';
import { RoofReplacement } from './components/RoofReplacement';
import { Process } from './components/Process';
import { Testimonials } from './components/Testimonials';
import { QuoteForm } from './components/QuoteForm';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { StickyMobileCTA } from './components/StickyMobileCTA';
export function App() {
  return <div className="min-h-screen w-full bg-white text-[#1a2332] selection:bg-[#2DB8E0]/30" data-id="element-0">
      <TopBar data-id="element-1" />
      <Header data-id="element-2" />
      <CouponBanner data-id="element-3" />
      <main data-id="element-4">
        <Hero data-id="element-5" />
        <TrustBar data-id="element-6" />
        <ShingleFocus data-id="element-7" />
        <RoofReplacement data-id="element-8" />
        <Process data-id="element-9" />
        <Testimonials data-id="element-10" />
        <QuoteForm data-id="element-11" />
        <FAQ data-id="element-12" />
        <FinalCTA data-id="element-13" />
      </main>
      <Footer data-id="element-14" />
      <StickyMobileCTA data-id="element-15" />
    </div>;
}